// constants
import { InfluencerActionTypes } from "./constants";

export interface InfluencerActionType {
  type:
    | InfluencerActionTypes.API_RESPONSE_SUCCESS
    | InfluencerActionTypes.API_RESPONSE_ERROR
    | InfluencerActionTypes.UPDATE_INFLUENCER
    | InfluencerActionTypes.UPDATE_INFLUENCER_PASSWORD
    | InfluencerActionTypes.CREATE_INFLUENCER
    | InfluencerActionTypes.GET_INFLUENCER
    | InfluencerActionTypes.GET_COUPON_REPORTS
    | InfluencerActionTypes.GET_COMMISION_REPORTS
    | InfluencerActionTypes.DELETE_INFLUENCER;
  payload: {} | string;
}

interface InfluencerDetails {
  id: string;
  name: string;
  phone: string;
  email: string;
  password: string;
}

// common success
export const InfluencerApiResponseSuccess = (actionType: string, data: InfluencerDetails | {}): InfluencerActionType => ({
  type: InfluencerActionTypes.API_RESPONSE_SUCCESS,
  payload: { actionType, data },
});
// common error
export const InfluencerApiResponseError = (actionType: string, error: string): InfluencerActionType => ({
  type: InfluencerActionTypes.API_RESPONSE_ERROR,
  payload: { actionType, error },
});

export const createInfluencer = (name: string, phone: string, email: string, password: string): InfluencerActionType => ({
  type: InfluencerActionTypes.CREATE_INFLUENCER,
  payload: {
    name,
    phone,
    email,
    password,
  },
});

export const getInfluencer = (): InfluencerActionType => ({
  type: InfluencerActionTypes.GET_INFLUENCER,
  payload: {},
});

export const deleteInfluencer = (id: string): InfluencerActionType => ({
  type: InfluencerActionTypes.DELETE_INFLUENCER,
  payload: { id },
});

export const updateInfluencerPassword = (email: string): InfluencerActionType => ({
  type: InfluencerActionTypes.UPDATE_INFLUENCER_PASSWORD,
  payload: { email },
});

export const updateInfluencer = (id: string, name: string, phone: string, email: string): InfluencerActionType => ({
  type: InfluencerActionTypes.UPDATE_INFLUENCER,
  payload: {
    id,
    name,
    phone,
    email,
  },
});

export const getCouponReportForInfluencer = (coupon: number | string): InfluencerActionType => ({
  type: InfluencerActionTypes.GET_COUPON_REPORTS,
  payload: {
    coupon,
  },
});

export const getCommisionReportForInfluencer = (coupon: number | string, from?: any, to?: any): InfluencerActionType => ({
  type: InfluencerActionTypes.GET_COMMISION_REPORTS,
  payload: {
    coupon,
    from,
    to,
  },
});
